// src/routes.tsx
import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import PrivateRoute from './components/auth/PrivateRoute';

interface RoutesProps {
  appRoutes: Array<any>;
}

const routes = ({ appRoutes }: RoutesProps) => {
  const mainLayoutRoutes = appRoutes.filter((r) => r.layout === 'main');
  const standaloneRoutes = appRoutes.filter((r) => r.layout !== 'main');

  return (
    <>
      {/* Routes that go inside MainLayout */}
      <Route element={<MainLayout appRoutes={appRoutes} />}>
        {mainLayoutRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<PrivateRoute>{route.element}</PrivateRoute>}
          />
        ))}
      </Route>

      {/* Routes that don't use MainLayout */}
      {standaloneRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={route.element} />
      ))}
    </>
  );
};

export default routes;
